import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Tabs,
  Tab,
  Typography,
  AccordionSummary,
  AccordionDetails,
  TextField,
  Tooltip,
  Box,
  Button,
} from "@mui/material";
import {
  resetSubcondominiumReadings,
  resetApartmentReadings,
  resetCondominiumReadings,
} from "../../../redux/slices/condominiumSlice";
const TabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
};

const MetersTableTab = ({ afs, heatMeter, setMeterType, colorMeter }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [value, setValue] = useState(0);
  const [colorMeterValue, setColorMeterValue] = useState(0);
  const [waterMeterValue, setWaterMeterValue] = useState(0);
  const handleChange = (event, newValue) => {
    dispatch(resetSubcondominiumReadings());
    dispatch(resetApartmentReadings());
    dispatch(resetCondominiumReadings());
    setValue(newValue);
    if (newValue == 0) {
      setMeterType(["AFS"]);
      setWaterMeterValue(0);
    }
    if (newValue == 1) {
      setMeterType(["RIPARTITORE"]);
    }
    if (newValue == 2) {
      setMeterType(["CALORIE / FRIGORIE", "Calorie", "Frigorie"]);
      setColorMeterValue(0);
    }
  };

  const colorMeterHandleChange = (event, newValue) => {
    setColorMeterValue(newValue);
    if (newValue == 0) {
      setMeterType(["CALORIE / FRIGORIE"]);
    }
    if (newValue == 1) {
      setMeterType(["CALORIE / FRIGORIE", "Calorie"]);
    }
    if (newValue == 2) {
      setMeterType(["CALORIE / FRIGORIE", "Frigorie"]);
    }
  };
  const waterMeterHandleChange = (event, newValue) => {
    setWaterMeterValue(newValue);
    if (newValue == 0) {
      setMeterType(["AFS"]);
    }
    if (newValue == 1) {
      setMeterType(["ACS"]);
    }
  };

  return (
    <Box>
      <Tabs value={value} onChange={handleChange}>
        <Tab label={t("AFS-ACS")} />
        <Tab label={t("RIPARTITORI")} />
        <Tab label={t("color_meter")} />
      </Tabs>
      <TabPanel value={value} index={0}>
        <Tabs value={waterMeterValue} onChange={waterMeterHandleChange}>
          <Tab label={"AFS"} />
          <Tab label={"ACS"} />
        </Tabs>
        <TabPanel value={waterMeterValue} index={0}>
          {afs}
        </TabPanel>
        <TabPanel value={waterMeterValue} index={1}>
          {afs}
        </TabPanel>
      </TabPanel>
      <TabPanel value={value} index={1}>
        {heatMeter}
      </TabPanel>
      <TabPanel value={value} index={2}>
        {colorMeter}
        {/*    <Tabs value={colorMeterValue} onChange={colorMeterHandleChange}>
          <Tab label={t("cal_fri")} />
          <Tab label={t("calories")} />
          <Tab label={t("frigories")} />
        </Tabs>
        <TabPanel value={colorMeterValue} index={0}>
          {colorMeter}
        </TabPanel>
        <TabPanel value={colorMeterValue} index={1}>
          {colorMeter}
        </TabPanel>
        <TabPanel value={colorMeterValue} index={2}>
          {colorMeter}
        </TabPanel> */}
      </TabPanel>
    </Box>
  );
};
export default MetersTableTab;
